/* import __COLOCATED_TEMPLATE__ from './seller-posting-affixed-input.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { htmlSafe } from '@ember/template';

class SellerPostingAffixedInputComponent extends Component {
  @tracked focus = false;

  get canShowAffixes() {
    return Boolean(this.args.value || this.focus);
  }

  get inputStyles() {
    const { canShowAffixes } = this;
    const { prefix, postfix, paddingPx } = this.args;

    const prefixCh = canShowAffixes && prefix ? prefix.length : 0;
    const postfixCh = canShowAffixes && postfix ? postfix.length : 0;

    const leftPadding = paddingPx
      ? `calc(${prefixCh}ch + ${paddingPx}px)`
      : `${prefixCh}ch`

    const rightPadding = paddingPx
      ? `calc(${postfixCh}ch + ${paddingPx}px)`
      : `${postfixCh}ch`

    return htmlSafe(`
      --left-padding: ${leftPadding};
      --right-padding: ${rightPadding};
    `);
  }

  get placeholder() {
    return this.canShowAffixes ?
      ''
      : this.args.placeholder;
  }

  @action
  handleBlur() {
    this.focus = false;
    this.args.onblur?.();
  }

  @action
  handleFocus() {
    this.focus = true;
    this.args.onfocus?.();
  }

  @action
  handleInput(value) {
    this.args.oninput?.(value);
  }
}

export default SellerPostingAffixedInputComponent;
